import * as React from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'

import { ENABLE_DIALOG_ERROR_STATUS_CODES } from 'api/utils'

import { deleteOfficialDuty, selectOfficialDutiesStatus } from 'slices/officialDutiesSlice'

import { CustomModal } from 'components/common'

type Props = {
  isOpen: boolean
  officialDutyId: number | undefined
  onSuccess: () => void
  onCancel: () => void
}

const HourlyWageDelete: React.FC<Props> = ({ isOpen, officialDutyId, onSuccess, onCancel }) => {
  const [modalErrorMessage, setModalErrorMessage] = React.useState<string | undefined>(undefined)
  const [submitted, setSubmitted] = React.useState(false)
  const { isRequesting, errorMessage } = useSelector(selectOfficialDutiesStatus, shallowEqual)
  const dispatch = useDispatch()

  const handleCancelClick = () => {
    setModalErrorMessage(undefined)
    onCancel()
  }

  const handleDeleteClick = () => {
    if (officialDutyId) {
      setSubmitted(true)
      dispatch(deleteOfficialDuty(officialDutyId))
    }
  }

  React.useEffect(() => {
    if (!submitted || isRequesting) {
      return
    }
    if (errorMessage === '') {
      onSuccess()
    } else if (!ENABLE_DIALOG_ERROR_STATUS_CODES.includes(errorMessage)) {
      // ENABLE_DIALOG_ERROR_STATUS_CODESのときにはエラーダイアログが出るのでNotificationは出さない
      setModalErrorMessage('削除できませんでした。')
    }
    setSubmitted(false)
  }, [submitted, isRequesting, errorMessage, dispatch, onSuccess])

  return (
    <CustomModal
      isOpen={isOpen}
      title="職掌の削除"
      approveColor="danger"
      approveLabel="削除"
      errorMessage={modalErrorMessage}
      onCancel={handleCancelClick}
      onApprove={handleDeleteClick}
      onHideNotification={() => setModalErrorMessage(undefined)}
    >
      <div className="pb-4">この職掌を本当に削除しますか？この操作は取り消せません。</div>
    </CustomModal>
  )
}

export default HourlyWageDelete
